/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerItineraryItem
 */
export interface PlannerItineraryItem {
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    itemType: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerItineraryItem
     */
    referenceId?: string | null;
    /**
     * 
     * @type {object}
     * @memberof PlannerItineraryItem
     */
    metadata?: object | null;
}

/**
 * Check if a given object implements the PlannerItineraryItem interface.
 */
export function instanceOfPlannerItineraryItem(value: object): value is PlannerItineraryItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('itemType' in value) || value['itemType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function PlannerItineraryItemFromJSON(json: any): PlannerItineraryItem {
    return PlannerItineraryItemFromJSONTyped(json, false);
}

export function PlannerItineraryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerItineraryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'itemType': json['item_type'],
        'title': json['title'],
        'location': json['location'] == null ? undefined : json['location'],
        'startDate': json['start_date'] == null ? undefined : json['start_date'],
        'endDate': json['end_date'] == null ? undefined : json['end_date'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'referenceId': json['reference_id'] == null ? undefined : json['reference_id'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function PlannerItineraryItemToJSON(json: any): PlannerItineraryItem {
    return PlannerItineraryItemToJSONTyped(json, false);
}

export function PlannerItineraryItemToJSONTyped(value?: PlannerItineraryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'item_type': value['itemType'],
        'title': value['title'],
        'location': value['location'],
        'start_date': value['startDate'],
        'end_date': value['endDate'],
        'notes': value['notes'],
        'reference_id': value['referenceId'],
        'metadata': value['metadata'],
    };
}

